import React from 'react';
import {
  CloseIcon,
} from "../../icons";

const sizeMap = {
  'modal-sm': 'tw:max-w-sm',
  'modal-md': 'tw:max-w-lg',
  'modal-lg': 'tw:max-w-2xl',
  'modal-xl': 'tw:max-w-4xl',
};

const AdminModalNew = ({
  show,
  title,
  description,
  children,
  footerContent,
  size = 'modal-md',
  centered = false,
  onClose,
}) => {
  if (!show) return null;

  const sizeClass = sizeMap[size] || 'tw:max-w-lg';

  return (
    <div
      className="tw:fixed tw:inset-0 tw:z-50 tw:flex tw:items-start tw:justify-center tw:overflow-y-auto tw:p-4"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      tabIndex="-1"
      aria-labelledby="adminModalLabel"
    >
      <div
        className={`tw:w-full ${sizeClass} ${centered ? 'tw:m-auto' : 'tw:mt-16'}`}
      >
        <div className="tw:bg-white tw:rounded-lg tw:shadow-xl tw:w-full">
          <div className="tw:p-10 tw:relative">
            <button
              type="button"
              onClick={onClose}
              className="tw:absolute tw:top-4 tw:!right-4 tw:text-gray-400 tw:hover:text-gray-700 tw:transition-colors tw:text-3xl tw:leading-none tw:bg-transparent tw:border-0 tw:cursor-pointer tw:p-1"
              aria-label="Close"
            >
              <CloseIcon
                color="#4E4E4E"
              />
            </button>

            {title && (
              <div className="tw:mb-3 tw:pr-8">
                <label
                  className="tw:text-lg tw:font-bold tw:mb-0"
                >
                  {title}
                </label>
                {description && (
                  <p className="tw:text-sm tw:text-gray-500 tw:mt-1">
                    {description}
                  </p>
                )}
              </div>
            )}

            {children}
          </div>

          {footerContent && (
            <div className="tw:border-t tw:border-gray-200 tw:px-6 tw:py-4 tw:rounded-b-2xl">
              {footerContent}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminModalNew;
